import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ShowMoreAndLess from '@components/filterComponents/showMoreAndLess';

import { toggleCheckbox } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';
import { fetchUserList } from '@store/actions/UserAction';

const CreatedBy = () => {
	const [users, setUsers] = useState([]);
	const userList = useSelector((store) => store.userStore);
	const [showMore, setShowMore] = useState(false);
	const filterData = useSelector((store) => store.filterFieldStore);

	useEffect(() => {
		setUsers(userList);
	}, [userList]);

	const dispatch = useDispatch();

	useEffect(() => {
		if (userList?.length === 0) {
			dispatch(fetchUserList());
		}
	}, []);

	const renderCreatedByList = () => {
		return users.map((user, index) => {
			if (!showMore && index > 4) return '';
			return (
				<div className="form-group" key={`filter_brand_${user.id}`}>
					<input
						type="checkbox"
						id={`created_by_${user.id}`}
						name={`created_by_${user.id}`}
						value={user.id}
						onChange={(e) => handleCheckbox(e, user.name)}
						checked={toggleCheckbox(filterData, 'createdBy', `created_by_${user.id}`, user.id)}
					/>
					<label htmlFor={`created_by_${user.id}`}>
						<span>{user.name}</span>
					</label>
				</div>
			);
		});
	};

	const handleCheckbox = (e, title) => {
		let { value, checked, name } = e.target;
		let data = {
			name: 'createdBy',
			key: value,
			value: title,
			identifier: name,
			checked: checked
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	const handleUserSearch = (e) => {
		dispatch(fetchUserList(e.target.value));
	};

	return (
		<div className="card">
			<div className="card-header" id="headingFive">
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target="#collapseCreated"
						aria-expanded="false"
						aria-controls="collapseCreated"
					>
						Owner
					</button>
				</h5>
			</div>

			<div
				id="collapseCreated"
				className="collapse"
				aria-labelledby="headingFive"
				data-parent="#accordion"
			>
				<div className="card-body">
					<div className="form-group size36 m-0 search-filter">
						<div className="with-icon right-icon">
							<input
								type="text"
								autoComplete="off"
								placeholder="Search"
								onChange={handleUserSearch}
							/>
							<span className="right-icon">
								<svg
									width="17"
									height="17"
									viewBox="0 0 17 17"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M7.5 0C11.6421 0 15 3.35786 15 7.5C15 9.21015 14.4276 10.7866 13.464 12.0483L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3466 17.0676 15.7794 17.0953 15.3871 16.7903L15.2929 16.7071L12.0483 13.464C10.7866 14.4276 9.21015 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0ZM7.5 2C4.46243 2 2 4.46243 2 7.5C2 10.5376 4.46243 13 7.5 13C8.85114 13 10.0885 12.5128 11.0459 11.7045C11.091 11.5536 11.1738 11.412 11.2929 11.2929C11.412 11.1738 11.5536 11.091 11.7041 11.0446C12.5128 10.0885 13 8.85114 13 7.5C13 4.46243 10.5376 2 7.5 2Z"
										fill="#9AA1AF"
									/>
								</svg>
							</span>
						</div>
					</div>
					<div className="custom-chekbox">{renderCreatedByList()}</div>
					<ShowMoreAndLess showMore={showMore} setShowMore={setShowMore} items={users} />
				</div>
			</div>
		</div>
	);
};

export default CreatedBy;
